<template>
  <div class="GoogleSettings mt-1">
    <v-select
        class="mb-3"
        outlined
        dense
        :value="selectedNode.settings.search"
        @input="(val) => onUpdate(val, 'settings.search')"
        item-text="name"
        item-value="name"
        :items="availableInputFields"
        label="Search string"
        clearable
    ></v-select>
    <v-switch
        label="Full Text Search (search in name if disabled)"
        class="mt-2"
        :input-value="selectedNode.settings.inName"
        @change="toggleInNameOption">
    </v-switch>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import cloneDeep from "lodash/cloneDeep";

const {
  mapGetters: workflowDetailsGetters,
  mapActions: workflowDetailsActions,
} = createNamespacedHelpers('workflows/details');

export default {
  name: 'google-search-in-drive-settings',
  components: {},
  props: {
    availableInputFields: {required: true},
  },
  mixins: [helpers],
  data() {
    return {
      newInput: undefined,
      testOutput: null,
      showDialog: false,
      error: '',
      output: '',
    };
  },
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
    settings() {
      return this.selectedNode.settings;
    },
  },
  methods: {
    ...workflowDetailsActions(['executeSingleAction']),
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    toggleInNameOption() {
      const settings = cloneDeep(this.settings);
      settings.isMultiPage = !settings.inName;
      this.onUpdate(settings, 'settings');
    },
  },
};
</script>

<style scoped lang="scss">
@import './google-settings';
</style>
